var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h4',[_vm._v(" Number of flights ")]),_c('div',{staticClass:"bar-chart-holder"},[_c('BarChart',{staticClass:"bar-chart",attrs:{"item-data":_vm.itemData,"height":150}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }